import { Auth } from '@better-auth-ui/heroui'
import { viewPaths } from '@better-auth-ui/core'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { z } from 'zod'
import { PublicLayout } from '~/components/layout/public-layout'
import { createSessionQuery } from '~/lib/session-query'
import { redirect } from '@tanstack/react-router'

const VALID_AUTH_PATHS = ['sign-in', 'sign-up', 'forgot-password', 'reset-password', 'verify-email']

export const Route = createFileRoute('/auth/$pathname')({
  validateSearch: z.object({
    redirectTo: z.string().optional(),
    redirect: z.string().optional(), // 兼容旧代码
  }),
  beforeLoad: async ({ params: { pathname }, context: { queryClient }, search }) => {
    if (!Object.values(viewPaths.auth).includes(pathname)) {
      throw notFound()
    }

    // Convert relative redirect URLs to absolute URLs to prevent Better Auth from
    // redirecting users to the backend API domain (api.tabetabi.cc) instead of the frontend.
    let hasRelativeRedirect = false
    const updatedSearch = { ...search }

    if (search.redirectTo && search.redirectTo.startsWith('/')) {
      const origin = typeof window !== 'undefined' ? window.location.origin : (import.meta.env.VITE_APP_URL || 'https://tabetabi.cc')
      updatedSearch.redirectTo = `${origin}${search.redirectTo}`
      hasRelativeRedirect = true
    }
    if (search.redirect && search.redirect.startsWith('/')) {
      const origin = typeof window !== 'undefined' ? window.location.origin : (import.meta.env.VITE_APP_URL || 'https://tabetabi.cc')
      updatedSearch.redirect = `${origin}${search.redirect}`
      hasRelativeRedirect = true
    }

    if (hasRelativeRedirect) {
      throw redirect({
        to: '/auth/$pathname',
        params: { pathname },
        search: updatedSearch,
        replace: true,
      })
    }

    const sessionData = await queryClient.fetchQuery(createSessionQuery(queryClient))
    if (sessionData?.session) {
      throw redirect({
        to: (search.redirectTo || search.redirect || '/dashboard') as any,
        replace: true,
      })
    }
  },
  component: AuthPage,
})

function AuthPage() {
  const { pathname } = Route.useParams()

  // 映射 kbab-case 到 camelCase (如 'sign-in' -> 'signIn')
  const viewKey = pathname.replace(/-([a-z])/g, (_, group1) => group1.toUpperCase())
  // 提供显式的 redirectTo，避免 Better Auth 回调到 api.tabetabi.cc
  const redirectUrl = typeof window !== 'undefined' ? `${window.location.origin}/dashboard` : 'https://tabetabi.cc/dashboard'

  return (
    <PublicLayout>
      <div className="container mx-auto flex min-h-[calc(100vh-128px)] flex-col items-center justify-center p-4">
        <Auth view={viewKey as any} path={pathname} />
      </div>
    </PublicLayout>
  )
}
